"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RememberedAccountsLayout = require("./RememberedAccountsLayout");
Object.keys(_RememberedAccountsLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RememberedAccountsLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RememberedAccountsLayout[key];
    }
  });
});